export default __webpack_public_path__ + "static/media/settings-img.a63930cc.png";